<template>
	<card title="Current Prescription">
		<div class="sk-group" v-if="hasData">
			<div class="sk-group-list" v-for="item in collection" :key="item.id">
				<div class="sk-group-list-item">
					<div class="sk-group-list-item-value">
						<span>{{ item.name }}</span>
						<span class="sk-group-list-item-label">Dose {{ item.dose }}</span>
					</div>
					<div class="sk-group-list-item-hour"><i class="sk-icon sk-icon-small sk-icon-hour"></i> {{ getHour(item.hour) }}</div>
				</div>
			</div>
		</div>
		<div class="sk-group sk-group-empty" v-if="!hasData">
			<div>{{ $t('Don\'t have readings to show.') }}</div>
		</div>
		<template v-slot:more-options>
			<card-option-item-link route="WatchPillsManage" :args="{ watch_id: patient.id }" :title="$t('See More')" />
		</template>
	</card>
</template>

<script>
import CardOptionItemLink from '@/modules/common/CardOptionItemLink'
import moment from 'moment';
import { mapGetters } from 'vuex'
import Card from '@/modules/common/Card'
import Datetime from '@/utils/Datetime'
export default {
	name: 'card-pacient-current-prescription',
	components: {
		Card,
		CardOptionItemLink
	},
	props: {
		patient: {
			type: Object,
			default: () => ({})
		},
		datetime: {
			type: Object,
			default: () => ({
				minute: 0,
				hour: 0,
				day: 0,
				month: 0,
				year: 0
			})
		}
	},
	data() {
		return {
			type: 1,
			default: {},
			collection: []
		}
	},
	computed: {
		hasData: function() {
			return this.collection.length > 0
		},
		...mapGetters({
			getPatientPills: 'PATIENTS_PILLS_OF_DAY'
		}),
	},
	methods: {
		getHour: (value) => moment('0000-01-01T'+value).format('kk:mm'),
	},
	created() {
		this.collection = this.getPatientPills(this.patient, this.datetime)
	}
}
</script>

<style scope>
</style>



// WEBPACK FOOTER //
// src/modules/pacient/CardPacientCurrentPrescription.vue